import React, { Component } from 'react';
import Connector from '../../data/Connector';
import Moment from 'moment';
import 'moment/locale/es';
import Firebase from 'firebase';
import HelperBilling from '../../helper/Billing';
import Cal from '../../helper/Calendar';
import HelperEmptyImg from '../../helper/EmptyLarge';
import Navigation from '../../components/Navigation';
import * as ROUTES from '../../constants/routes';
import { Link, withRouter } from 'react-router-dom';
import EventEmitter from '../../helper/Emitter';
import { AuthUserContext, withAuthorizationMember } from '../../components/Session';

import { withTranslation } from "react-i18next";
import lang from 'i18next';



class ActivityPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: global.userName,
      done: false,
      num: global.num,
      sessions: [],
      notifications: [],
      events: [],
      subscriptions: global.subscriptions,
      showOverlay: false,
      hidden: 'hidden',
      margin: 0,
    };
  }


  componentDidMount() {
    global.activityLocked = false
    var arr = this.props.location.pathname.split('/')
    var id = arr[arr.length-2]
    if(id !== 'home' && id !== 'member') {
      global.uid = id
    }
    Connector.setUser()
    document.title = 'Activity - '+global.userBusiness
    window.scrollTo(0, 0)
    global.programLocked = false

    this.setState({
      done: true
    })

    if(global.message !== '') {
      setTimeout(() => {
        EventEmitter.dispatch('showMessage', global.message);
        global.message = ''
      }, 300);
      
    }
    EventEmitter.subscribe('userLoaded', (event) => this.checkSpace())
    EventEmitter.subscribe('sessionsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('eventsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('productsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('habitsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('locationSet', (event) => this.configureData())
    this.configureData()
  }


  componentWillUnmount() {
    EventEmitter.unsubscribe('userLoaded', () => {})
    EventEmitter.unsubscribe('sessionsLoaded', () => {})
    EventEmitter.unsubscribe('eventsLoaded', () => {})
    EventEmitter.unsubscribe('productsLoaded', () => {})
    EventEmitter.unsubscribe('habitsLoaded', () => {})
    EventEmitter.unsubscribe('locationSet', () => {})
  }
  

  checkSpace() {
    if(global.uid === '') {
      this.props.history.push(ROUTES.LOADING)
    } else {
      var found = false
      for(var item of global.userStaff) {
        if(item.id === global.uid) {
          found = true
        }
      }
      if(found) {
        document.title = lang.t('header:title.welcomepage')+' - '+global.userBusiness
        this.configureData()
      } else {
        this.props.history.push(ROUTES.LOADING)
      }
    }
  }


  configureData() {
    var tmp = []
    // Sessions
    for(var item1 of global.sessions) {
      var name = "PT Session"
      if(item1.data.name !== undefined) {
        name = item1.data.name
      }
      if(item1.data.group) {
        name = "Class"
        if(item1.data.client !== '') {
          name = item1.data.client
        }
      }
      if(item1.data.availability) {
          name = "1:1 Availability"
      }
      if(Moment(item1.data.timestamp, 'X') > Moment().add(-14, 'days')) {
        var desc = name+"\n"+Cal.getSpecialDate(item1)
        // Bookings
        if(item1.data.bookings !== undefined) {
          for(var bk of item1.data.bookings) {
            if(bk.indexOf(global.spaceClient) !== -1 && bk.indexOf("booking") !== -1) {
              var ar = bk.split("||")
              var date = item1.data.timestamp
              if(ar.length > 3) {
                  date = ar[3]
              }
              desc = name+" - "+Cal.getSpecialDate(item1, false)+"\nBooked in "+Moment(date, 'X').format('llll')
              tmp.push({
                id: item1.id,
                name: 'You booked in',
                desc: desc,
                type: 'session',
                date: parseInt(date),
                info: 'booking'
              })
            }
            // Family
            for(var cl1 of global.userLinked) {
              if(bk.indexOf(cl1) !== -1 && bk.indexOf("booking") !== -1) {
                var ar2 = bk.split("||")
                var date2 = item1.data.timestamp
                if(ar2.length > 3) {
                    date2 = ar2[3]
                }
                desc = name+" - "+Cal.getSpecialDate(item1, false)+" h\nBooked in "+Moment(date2, 'X').format('llll')
                tmp.push({
                  id: item1.id,
                  name: this.getName(cl1)+" booked in",
                  desc: desc,
                  type: 'session',
                  date: parseInt(date2),
                  info: 'booking'
                })
              }
            }
            if(bk.indexOf(global.spaceClient) !== -1 && bk.indexOf("cancellation") !== -1) {
              var ar3 = bk.split("||")
              var date3 = item1.data.timestamp
              if(ar3.length > 3) {
                date3 = ar3[3]
              }
              desc = name+" - "+Cal.getSpecialDate(item1, false)+"\nCancelled "+Moment(date3, 'X').format('llll')
              tmp.push({
                id: item1.id,
                name: 'You cancelled a booking',
                desc: desc,
                type: 'session',
                date: parseInt(date3),
                info: 'booking'
              })
            }
            // Family
            for(var cl2 of global.userLinked) {
              if(bk.indexOf(cl2) !== -1 && bk.indexOf("cancellation") !== -1) {
                var ar = bk.split("||")
                var date4 = item1.data.timestamp
                if(ar.length > 3) {
                    date4 = ar[3]
                }
                desc = name+" - "+Cal.getSpecialDate(item1, false)+"\nCancelled "+Moment(date4, 'X').format('llll')
                tmp.push({
                  id: item1.id,
                  name: this.getName(cl2)+" cancelled a booking",
                  desc: desc,
                  type: 'session',
                  date: parseInt(date4),
                  info: 'booking'
                })
              }
            }
          }
        }
        // Comments
        for(var comment of item1.comments) {
          if(item1.data.clients !== undefined) {
            if(Moment(comment.data.date, 'X') > Moment().add(-14, 'days') && (item1.data.clients.indexOf(global.spaceClient) !== -1 || !item1.data.group) && comment.data.sender !== global.spaceClient) {
              if(global.userComments && global.userVerified) {
                tmp.push({
                  id: item1.id,
                  name: 'New session comment',
                  desc: name+Cal.getSpecialDate(item1)+"\n"+Moment(comment.data.date, 'X').format('llll'),
                  type: 'session',
                  date: parseInt(comment.data.date),
                  info: 'booking'
                })
              }
            }
          }
        }
        // High fives
        if(item1.data.highfives !== undefined) {
          for(var hf of item1.data.highfives) {
            var ar = hf.split("||")
            var date = item1.data.timestamp
            if(ar.length > 2) {
              date = ar[2]
            }
            var cname = "another member"
            if(ar[0] === global.spaceClient) {
              for(var client of global.clients) {
                if(client.id === ar[1]) {
                  cname = client.data.name
                }
              }
                desc = name+" - "+Cal.getSpecialDate(item1, false)+"\nFrom "+cname+" - "+Moment(date, 'X').format('llll')
                tmp.push({
                  id: item1.id,
                  name: 'You received a high five',
                  desc: desc,
                  type: 'session',
                  date: parseInt(date),
                  info: 'highfive'
                })
            } else if(ar[1] === global.spaceClient) {
              for(var client2 in global.clients) {
                if(client2.id === ar[0]) {
                  cname = client.data.name
                }
              }
              desc = name+" - "+Cal.getSpecialDate(item1, false)+"\nTo "+cname+" - "+Moment(date, 'X').format('llll')
              tmp.push({
                id: item1.id,
                name: 'You gave a high five',
                desc: desc,
                type: 'session',
                date: parseInt(date),
                info: 'highfive'
              })
            }
          }
        }
      }
    }

    // Payments
    for(var item2 of global.payments) {
      if(Moment(item2.data.date, 'DD/MM/YYYY HH:mm') > Moment().add(-14, 'days') && item2.data.client === global.spaceClient) {
        var desc = global.curSym+(item2.data.amount/100).toFixed(2)+"\n"+Moment(item2.data.date, 'DD/MM/YYYY HH:mm').format('llll')
        if(item2.data.timestamp !== undefined) {
          desc = global.curSym+(item2.data.amount/100).toFixed(2)+"\n"+Moment(item2.data.timestamp, 'X').format('llll')
        }
        var type = item2.data.receipt
        if(item2.data.type === "Cash") {
            type = "Cash"
        }
        tmp.push({
          id: item2.id,
          name: 'Payment made',
          desc: desc,
          type: 'payment',
          date: parseInt(Moment(item2.data.date, 'DD/MM/YYYY HH:mm').format('X')),
          info: type
        })
      }
    }

    // Upcoming payments
    for(var item3 of global.subscriptions) {
      var pause = Moment('01/01/1900', 'DD/MM/YYYY')
      if(item3.data.pause !== "" && item3.data.pause !== undefined) {
        pause = Moment(item3.data.pause, 'X')
      }
      if(Moment(item3.data.next, 'X') < Moment().add(7, 'days') && Moment(item3.data.next, 'X') > Moment() && Moment(item3.data.next, 'X') > pause) {
        var desc = global.curSym+(item3.data.price/100).toFixed(2)+"\n"+Moment(item3.data.next, 'X').format('llll')
        tmp.push({
          id: item3.id,
          name: 'Upcoming payment',
          desc: desc,
          type: 'payment',
          date: parseInt(item3.data.next),
          info: 'upcoming'
        })
      }
    }
  
    // Invoices
    for(var item4 of global.invoices) {
      if(Moment(item4.data.date, 'X') > Moment().add(-14, 'days') && item4.data.client === global.spaceClient) {
          let desc = global.curSym+item4.data.price.toFixed(2)+"\nSent "+Moment(item4.data.date, 'X').format('llll')
          tmp.push({
            id: item4.id,
            name: 'Invoice',
            desc: desc,
            type: 'invoice',
            date: parseInt(item4.data.date),
            info: ''
          })
      }
    }

    // Forms
    //if(User.space.showForms) {
      for(var item5 of global.forms) {
        if(item5.data.date !== undefined) {
          if(Moment(item5.data.date, 'X') > Moment().add(-14, 'days')) {
            var desc = item5.data.name+"\n"+Moment(item5.data.date, 'X').format('llll')
            tmp.push({
              id: item4.id,
              name: 'Form filled',
              desc: desc,
              type: 'form',
              date: parseInt(item5.data.date),
              info: ''
            })
          }
        }
      }
    //}

    // Habits
    if(global.habits.length > 0 && global.spaceAllowHabits) {
      for(var item6 of global.habits) {
          var add = true
          if(item6.data.days !== undefined) {
            for(var day of item6.data.days) {
                if(day.indexOf(Moment().format('DD/MM/YYYY')) !== -1) {
                  add = false
                }
            }
          }
          if(Moment(item6.data.end, 'X') < Moment()) {
            add = false
          }
          if(add) {
            var desc = item6.data.amount+" "+item6.data.unit+" per "+(item6.data.nterval === 1 ? "day" : "week")+"\nStarted "+Moment(item6.data.start, 'X').format('llll')
            tmp.push({
              id: item6.id,
              name: item6.data.name,
              desc: desc,
              type: 'habit',
              date: parseInt(Moment().add(4, 'days').format('X')),
              info: ''
            })
          }
      }
    }

    if(!global.userVerified) {
      tmp = []
    }
    this.setState({
      notifications: tmp
    })
  }


  getBg() {
    var label = 'image'
    if(!this.state.done && this.state.num === 99) {
      var num = parseInt(Math.random()*6+1)
      global.num = num
      this.setState({
        num: num
      })
    }
    label = 'image bg'+this.state.num
    return label
  }


  getIcon(item) {
    var label = 'event'
    if(item.type === 'payment') {
      label = 'card'
      if(item.info === 'Cash') {
        label = 'dollar'
      }
      if(item.info === 'upcoming') {
        label = 'refresh'
      }
    }
    if(item.type === 'invoice') {
      label = 'invoice'
    }
    if(item.info === 'highfive') {
      label = 'highfive'
    }
    if(item.info === 'comment') {
      label = 'comment'
    }
    return label
  }


  getColor(item) {
    var label = 'primary'
    if(item.type === 'payment' || item.type === 'invoice') {
      label = 'secondary'
    }
    if(item.type === 'form' || item.type === 'habit') {
      label = 'quarternary'
    }
    return label
  }


  getName(id) {
    var label = "Member"
    for(var item of global.clients) {
      if(item.id === id) {
        label = item.data.name
      }
    }
    return label
  }


  clickNotification(item) {
    if(item.type === 'session') {
      this.props.history.push(global.uid+'/calendar/session/'+item.id)
    }
    if(item.type === 'payment' && item.info !== 'upcoming') {
      this.showOverlayPayment(item.id)
    }
    if(item.type === 'invoice') {
      this.props.history.push(global.uid+'/admin/invoice/'+item.id)
    }
    if(item.type === 'form') {
      this.props.history.push(global.uid+'/form/'+item.id)
    }
    if(item.type === 'habit') {
      this.props.history.push(global.uid+'/health/habit/'+item.id)
    }
  }



  // Payments overlay ------------------------------------------------------------



  showOverlayPayment(id) {
    var item = null
    for(var pay of global.payments) {
      if(pay.id === id) {
        item = pay
      }
    }
    this.setState({
      showOverlay: true,
      currentPayment: item
    })
    setTimeout(() => {
      this.setState({hidden: ''});
    }, 100);
  }


  hideOverlayPayment() {
    this.setState({hidden: 'hidden'})
    setTimeout(() => {
      this.setState({showOverlay: false});
    }, 500);
  }


  renderMethod() {
    if(this.state.currentPayment.data.fee !== undefined) {
      if(this.state.currentPayment.data.fee === 0) {
        return (
          <div className="lft">{lang.t('admin:label.other')}</div>
        )
      } else {
        return (
          <div className="lft">{this.state.currentPayment.data.type} {lang.t('admin:label.ending')} {this.state.currentPayment.data.last4}</div>
        )
      }
    } else {
      return (
        <div className="lft">{this.state.currentPayment.data.type} {lang.t('admin:label.ending')} {this.state.currentPayment.data.last4}</div>
      )
    }
  }


  renderOverlayButton() {
    if(global.spaceAllowHabits) {
      return (
        <a className="btn primary" href={'https://ptmate.app/billing/receipt/'+this.state.currentPayment.id} target="_blank" rel="noopener noreferrer">{lang.t('modal:payment.button')}</a>
      )
    } else {
      return (
        <a href={this.state.currentPayment.data.receipt} target="_blank" rel="noopener noreferrer" className="btn primary">{lang.t('modal:payment.button')}</a>
      )
    }
  }


  renderPaymentName(item) {
    var label = item.data.name
    if(item.data.subscription !== undefined && item.data.subscription !== '' && this.state.item !== null) {
      for(var sub of this.state.products) {
        if(sub.id === item.data.subscription) {
          label = sub.data.name
        }
      }
    }
    if(item.data.name.indexOf('Invoice ') !== -1 || item.data.name.indexOf('Subscription ') !== -1) {
      label = lang.t('admin:label.membership')
    }
    return label
  }


  renderPaymentDate(item) {
    var label = Moment(item.data.date, 'DD/MM/YYYY HH:mm').locale(lang.language).format('D MMM YYYY')
    if(item.data.timestamp !== undefined) {
      label = Moment(item.data.timestamp, 'X').locale(lang.language).format('D MMM YYYY')
    }
    return label
  }


  renderOverlayPayment() {
    if(this.state.showOverlay) {
      return (
        <div className={'overlay '+this.state.hidden}   >
          <div className="box">
            <h2 className="mb-20 lft">{lang.t('modal:payment.title')}</h2>
            <button className="btn tertiary small close rgt" onClick={() => this.hideOverlayPayment()}>{lang.t('modal:common.close')}</button>
            <div className="info clear">
              <p className="label">{this.renderPaymentName(this.state.currentPayment)}</p>
              <p className="big">{HelperBilling.showAmount((this.state.currentPayment.data.amount/100))}</p>
            </div>
            <div className="table">
              <div className="label lft">{lang.t('modal:payment.date')}</div>
              <div className="lft">{this.renderPaymentDate(this.state.currentPayment)}</div>
              <div className="label lft clear">{lang.t('modal:payment.method')}</div>
              <div className="lft">{this.renderMethod()}</div>
              <div className="clear"></div>
            </div>
            <div className="sv-30"></div>
            {this.renderOverlayButton()}
          </div>
        </div>
      )
    }
  }



  // Display stuff ------------------------------------------------------------



  renderNotifications() {
    if(this.state.notifications.length === 0) {
      return (
        <div className="empty large pt-60 clear">
          <div className="illustration mb-30">
            <div className="img1"></div>
            <div className="img2"></div>
            <div className="img3"></div>
            <div className="img4"></div>
            {HelperEmptyImg.renderImage('activity')}
          </div>
          <div className="data">
            <h3 className="mb-20">{lang.t('empty:activity.title')}</h3>
            <p style={{whiteSpace: 'pre-wrap'}}>{lang.t('empty:activity.text')}</p>
          </div>
        </div>
      )
    } else {
      var list = this.state.notifications
      list.sort((a,b) => Moment(b.date, 'X') - Moment(a.date, 'X'))
      return (
        <div>
          {list.map((item, index) => (
            <div className="box list highlight mb-10" key={item.id+index} onClick={() => this.clickNotification(item)}>
              <div className="col-10">
                <div className={'icon '+this.getColor(item)}>
                  <div className={'inner '+this.getIcon(item)}></div>
                </div>
                <p className="lft" style={{whiteSpace: 'pre-wrap'}}><strong>{item.name}</strong><br/>{item.desc}</p>
                <div className="clear"></div>
              </div>
              <div className="clear"></div>
            </div>
          ))}
        </div>
      )
    }
  }


  renderNav() {
    if(global.userCommunity) {
      return (
        <div>
          <Link to={'/'+global.uid+'/home'} className="tab">
            <p>{lang.t('nav:home.overview')}</p>
            <div className="bg"></div>
          </Link>
          <Link to={'/'+global.uid+'/community'} className="tab">
            <p>{lang.t('nav:home.community')}</p>
            <div className="bg"></div>
          </Link>
          <Link to={'/'+global.uid+'/activity'} className="tab active">
            <p>{lang.t('nav:home.activity')}</p>
            <div className="bg"></div>
          </Link>
        </div>
      )
    } else {
      return (
        <div>
          <Link to={'/'+global.uid+'/home'} className="tab">
            <p>{lang.t('nav:home.overview')}</p>
            <div className="bg"></div>
          </Link>
          <Link to={'/'+global.uid+'/activity'} className="tab active">
            <p>{lang.t('nav:home.activity')}</p>
            <div className="bg"></div>
          </Link>
          <Link to={'/'+global.uid+'/calendar'} className="tab">
            <p>{lang.t('nav:home.calendar')}</p>
            <div className="bg"></div>
          </Link>
        </div>
      )
    }
  }


  renderMainImage() {
    if(global.spaceBackground === '') {
      return (
        <div className={this.getBg()}>
          <div className={'gradient theme-'+global.spaceTheme}></div>
        </div>
      )
    } else {
      return (
        <div className='image bg' style={{backgroundImage: 'url('+global.spaceBackground+')', backgroundSize: 'cover'}}></div>
      )
    }
  }


  renderName() {
    if(this.state.name !== '' && this.state.name !== null) {
      const ar = this.state.name.split(' ')
      return ar[0]
    }
  }


  renderBase() {
    return (
      <div className={'theme-'+global.spaceTheme}>
        <div className="content member">
          <div className="member-header mb-10">
            {this.renderMainImage()}
            <div className="member-main">
              <div className="business">
                <div className="avatar" style={{backgroundImage: 'url('+global.spaceImage+')'}}> </div>
                <h3>{global.userBusiness}<br/><span>{lang.t('header:title.memberarea')}</span></h3>
              </div>
              <h2 className="mb-30">{lang.t('header:title.welcome')} {this.renderName()}</h2>
              {this.renderNav()}
            </div>
            <div className="clear"></div>
          </div>

          <div className="listheader">
            <h3>{lang.t('header:home.recentactivity')}</h3>
            <div className="clear"></div>
          </div>
          {this.renderNotifications()}
          <div className="clear sv-40"></div>
        </div>
        <Navigation active='overview' />
        {this.renderOverlayPayment()}
      </div>
    )
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['nav','header','common','overview','calendar','empty'])(withRouter(withAuthorizationMember(condition)(ActivityPage)));